<div class="flex justify-center">
  <div class="p-6 w-full sm:w-96 py-14 md:py-28">
    @switch (loginStep()) {
      @default {
        <div class="text-center mb-5 flex flex-col gap-3">
          <img alt="{{ businessName }} Logo" class="h-20 mx-auto" height="80" width="80" [ngSrc]="logoPath" />
          <div class="text-3xl font-semibold">Welcome Back</div>
          <span> Enter your email to sign in to {{ businessName }} </span>
        </div>
        <form class="flex flex-col items-center gap-3" [formGroup]="emailForm" (ngSubmit)="loginStep.set('password')">
          <input class="w-full text-center" formControlName="email" id="email" pInputText placeholder="Email Address" type="email" />
          <button
            aria-label="Continue"
            class="w-auto"
            icon="pi pi-arrow-right"
            iconPos="right"
            label="Continue"
            pButton
            pRipple
            text="true"
            type="submit"
            [disabled]="emailForm.invalid"></button>
        </form>
        @if (providers) {
          <p-divider align="center" styleClass="my-3">
            <span class="text-sm">OR</span>
          </p-divider>
          @for (provider of providers; track $index) {
            <button
              aria-label="Continue with {{ provider | titlecase }}"
              class="w-full mb-2"
              icon="pi pi-{{ provider }}"
              label="Continue with {{ provider | titlecase }}"
              pButton
              pRipple
              type="button"
              (click)="handleProviderChoice(provider)"></button>
          }
        }
      }
      @case ('password') {
        <form class="flex flex-col items-center w-full gap-3" [formGroup]="passwordForm" (ngSubmit)="handleUserLogin()">
          <div class="text-center flex flex-col gap-3">
            <img alt="{{ businessName }} Logo" class="h-20 mx-auto" height="80" width="80" [ngSrc]="logoPath" />
            <div class="text-3xl font-semibold">Enter Password</div>
            <span> Enter your password for {{ emailForm.value['email'] }} </span>
          </div>
          <p-password
            class="w-full"
            formControlName="password"
            id="password"
            inputStyleClass="w-full"
            placeholder="Password"
            styleClass="w-full"
            [feedback]="false"
            [toggleMask]="true" />
          <div class="flex items-center justify-between w-full gap-2">
            <div class="flex flex-row items-center gap-2">
              <p-checkbox class="-mt-1" formControlName="rememberMe" id="rememberme" inputId="rememberme" [binary]="true" />
              <label for="rememberme">Remember Me</label>
            </div>
            <button
              class="font-semibold text-primary-500 text-right cursor-pointer bg-transparent border-none p-0"
              type="button"
              (click)="loginStep.set('forgotPassword')">
              Forgot password?
            </button>
          </div>
          <button
            aria-label="Log In"
            class="w-auto"
            icon="pi pi-arrow-right"
            iconPos="right"
            label="Log In"
            pButton
            pRipple
            text="true"
            type="submit"
            [disabled]="passwordForm.invalid"></button>
        </form>
      }
      @case ('success') {
        <div class="flex flex-col justify-center items-center">
          <span class="flex items-center justify-center bg-cyan-100 text-cyan-800 rounded-full mb-3 h-20 w-20">
            <i class="pi pi-check !text-5xl"></i>
          </span>
          <div class="text-center flex flex-col gap-3">
            <div class="text-3xl font-semibold">Email Sent</div>
            <span>Email sent to {{ emailForm.value['email'] }}. You may now close this window.</span>
          </div>
        </div>
      }
      @case ('loading') {
        <div class="w-full flex justify-center">
          <p-progressSpinner />
        </div>
      }
      @case ('forgotPassword') {
        <div class="flex flex-col gap-3">
          <div class="text-center flex flex-col gap-3">
            <img alt="{{ businessName }} Logo" class="h-20 mx-auto" height="80" width="80" [ngSrc]="logoPath" />
            <div class="text-3xl font-semibold">Forgot Password</div>
            <span>Enter your email to receive a password reset email.</span>
          </div>
          <form class="flex flex-col items-center gap-3" [formGroup]="emailForm">
            <input class="w-full text-center" formControlName="email" id="email" pInputText placeholder="Email Address" type="email" />
            <button
              aria-label="Reset Password"
              class="w-auto"
              icon="pi pi-arrow-right"
              iconPos="right"
              label="Reset Password"
              pButton
              pRipple
              text="true"
              type="submit"
              [disabled]="emailForm.invalid"
              (click)="sendPasswordResetLink()"></button>
          </form>
        </div>
      }
    }
  </div>
</div>
